import { useState, useEffect, MutableRefObject } from 'react'

interface IntersectionObserverProps {
  target: MutableRefObject<Element | null>
  root?: Element | null
  rootMargin?: string
  threshold?: number | number[]
}

export const useIntersectionObserver = ({
  target,
  root = null,
  rootMargin = '0px',
  threshold = 0,
}: IntersectionObserverProps): IntersectionObserverEntry | null => {
  const [entry, setEntry] = useState<IntersectionObserverEntry | null>(null)

  useEffect(() => {
    if (!target.current) return

    const options: IntersectionObserverInit = { root, rootMargin, threshold }
    const observer = new IntersectionObserver((entries) => setEntry(entries[0]), options)

    observer.observe(target.current)

    return () => {
      observer.disconnect()
    }
  }, [target, root, rootMargin, threshold])

  return entry
}
